import { useState, useEffect } from 'react';
import { publicCoverageApi } from '../services/publicApi';
import { toCountryRecord } from '../utils/coverage';

export const useCountries = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      const { countries: data } = await publicCoverageApi.list();
      setCountries((data || []).map(toCountryRecord));
      setError(null);
    } catch (err) {
      console.error('Failed to fetch countries:', err);
      setError('Failed to load country data');
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    setLoading(true);
    fetchCountries();
  };

  return { countries, loading, error, refetch };
};
